import { render } from "./index.vue?vue&type=template&id=56866050&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=56866050&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/adx-app/adx-app/apps/stacks/apps/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56866050"]])

export default __exports__